import React from 'react'

import type { InsightConfigurationType } from '@/types/dashboard-types'

import Drilldown from './Drilldown'

interface DrilldownLinkProps {
  id: string
  linkContent: React.ReactNode
  configuration: InsightConfigurationType
}

// Note: do not use this in a tanstack table directly because it unmounts it and you lose your modal state
export const DrilldownLink: React.FC<DrilldownLinkProps> = ({ id, linkContent, configuration }) => {
  const [show, setShow] = React.useState(false)
  return (
    <>
      {show && (
        <Drilldown
          configuration={configuration}
          onClose={() => {
            setShow(false)
          }}
        />
      )}
      <a id={id} className="w-full h-full" onClick={() => setShow(true)} href="#">
        {linkContent}
      </a>
    </>
  )
}
